import React, { useMemo } from 'react';

// The server runs finpilot's own tab renderers and hands us their Rich output as
// HTML: plain text plus <span> elements carrying classes (b, dim, i, u, s, c-<color>,
// bg-<color>) or, for the rare non-ANSI color, an inline style. Everything else is
// dropped here so the panel can only ever contain text and styled spans.
const SPAN_RE = /<span\b([^<>]*)>|<\/span>/g;
const ATTR_RE = /\b(class|style)="([^"<>]*)"/g;

export function sanitize(html) {
  if (!html) return '';
  let depth = 0;
  let out = html.replace(SPAN_RE, (m, attrs) => {
    if (m === '</span>') { if (depth === 0) return ''; depth--; return '</span>'; }
    const keep = [];
    for (const [, k, v] of (attrs || '').matchAll(ATTR_RE)) {
      if (k === 'class' && /^[\w -]*$/.test(v)) keep.push(`class="${v}"`);
      if (k === 'style' && /^(?:(?:color|background):#[0-9a-fA-F]{3,8};?\s*)*$/.test(v)) keep.push(`style="${v}"`);
    }
    depth++;
    return `<span ${keep.join(' ')}>`;
  });
  // Any other tag is text; escape it.
  out = out.replace(/<(?!\/?span\b)/g, '&lt;');
  while (depth-- > 0) out += '</span>';
  return out;
}

export default function TuiPanel({ html }) {
  const safe = useMemo(() => sanitize(html), [html]);
  return <pre className="df-tui" dangerouslySetInnerHTML={{ __html: safe }} />;
}
